import { Box } from '@coolblue-development/becky';
import { Typography } from '@coolblue-development/freddy';
import EmailTransferIcon from '../../../Icons/EmailTransferIcon';
import { EmailTransfer } from '../../../../../models/Email';

interface TransferredBannerProps {
  transferDetails: EmailTransfer;
}

const TransferredBanner = ({ transferDetails }: TransferredBannerProps): JSX.Element => (
  <Box sx={{ margin: '16px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <EmailTransferIcon />
      <Typography variant="h6" color="subtle" sx={{ fontWeight: 400 }}>
        From <strong>{transferDetails.fromQueue}</strong> by {transferDetails.byAgent}
      </Typography>
    </Box>
  </Box>
);

export default TransferredBanner;
